export default __webpack_public_path__ + "static/media/places.ace8b6dd.png";